(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('centerLayer', function() {
    return {
      restrict: 'E',
      scope: { showLayer: '=', exit: '&', layerStyle: '=' },
      transclude: true,
      templateUrl: '/common/centerLayer.html?_hv=fa24fce',
      link: function (scope, element, attrs) {
        scope.close = function ($event) {
          if (scope.exit({$event: $event}))
          return;
          scope.showLayer = false;
        };

        if (scope.layerStyle) {
          scope.$watch(function() {
            return scope.layerStyle;
          }, function(newStyle, oldStyle) {
            if (newStyle != oldStyle) {
              $compile(element.contents())(scope);
            }
          });
        }
      }
    };
  });
})(window, window.angular);
